import { Button } from "@msuite/ui/button";
import { Icon } from "@msuite/ui/icons";
import { useTranslation } from "@msuite/ui/localization";
import { useQuery } from "@msuite/ui/query";
import { responseHandler } from "@msuite/ui/utils";
import { useNavigate } from "react-router";
import { ProjectCard } from "@/components/cards";
import { client } from "@/hono";

/** Props Interface */
interface ProjectPopoverProps {
	projectId: string | null;
}

export function ProjectPopover({ projectId }: ProjectPopoverProps) {
	/** Hooks */
	const _navigate = useNavigate();
	const { t } = useTranslation();

	/** Query */
	const { data: project } = useQuery({
		queryKey: ["projects", projectId ?? ""],
		queryFn: async () => {
			if (!projectId) return null;
			const response = await client.projects[":projectId"].$get({
				param: {
					projectId,
				},
			});
			const data = await responseHandler(response);
			return data.project;
		},
		enabled: !!projectId,
	});

	/** Functions */
	function handleOnNavigate() {
		window.open(`/projects/${projectId}`, "_blank");
	}

	/** Guard */
	if (!project) return null;

	/** Render */
	return (
		<div className="min-w-[600px] v-stack items-start">
			<div className="w-full">
				<ProjectCard project={project} />
			</div>
			<Button
				variant="white"
				onClick={handleOnNavigate}
				icon={<Icon name="ExternalLink" />}
			>
				{t("general.information")}
			</Button>
		</div>
	);
}
